export enum Permission {
    DeploymentRequest = 300,
    BankAccessoriesRequest = 301,
    RemovalRequest = 302,
    SupportAccessoriesRequest = 303,
    ReconfigureRequest = 304,
    PendingDeployment = 310,
    DeploymentHistory = 311,
    SupportHistory = 312,
    RemovalRequestList = 313,
    RemovalHistory = 314,
    ReconfigureHistory = 315,
    AccessioresRequestList = 316,
    BranchAdd = 320,
    RemoveBranch = 321,
    EditBranch = 322,
    CardRequest = 330,
    ViewCardRequestList = 331,
    ViewCardRequestHistory = 332,
    CardTransactionHeader = 340,
    TransactionReport = 341,
    CardTransactionHeaderUpdate = 342,
    ManageBankUsers = 350,
    ManageBankRoles = 360,
    RemoveRemovalRequestedTerminal = 351
}
 